// Administrator dashboard
import React from 'react';
import View from 'src/pages/coming-soon';

const Page = () => {
  return <View message={'Danh sách các đơn, giấy tờ chờ duyệt'} />;
};

export default Page;
